import { UseFormReturn } from "react-hook-form";
import { RestaurantFormData } from "@/types/restaurantForm";
import { EmailField } from "./fields/EmailField";
import { WebsiteField } from "./fields/WebsiteField";
import { PhoneField } from "./fields/PhoneField";

interface ContactFieldsProps {
  form: UseFormReturn<RestaurantFormData>;
}

export const ContactFields = ({ form }: ContactFieldsProps) => {
  return (
    <>
      <EmailField form={form} />
      <WebsiteField form={form} />
      <PhoneField form={form} />
    </>
  );
};